import React from "react";
import { Link } from "react-router-dom";
import AuthInput from "../../Components/AuthInput";
import useForgetPassword from "./useForgetPasswordNew";
import AuthScreenLayout from "../../Components/Auth/AuthScreenLayout";
import AuthBrandMark from "../../Components/Auth/AuthBrandMark";
import { useReduxStore } from "../../hooks/useReduxStore";
import { authPrimaryButtonClass as primaryBtn } from "../../Components/Auth/authClasses";

export default function ForgetPasswordNew() {
  const { getState } = useReduxStore();
  const { settings } = getState("AUTH") || {};

  const {
    register,
    handleSubmit,
    onSubmit,
    errors,
    emailSent,
    email,
    loading,
  } = useForgetPassword();

  return (
    <AuthScreenLayout cardMaxWidthClass="max-w-2xl">
      <AuthBrandMark settings={settings} />

      {emailSent ? (
        <div className="space-y-6 text-center">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-emerald-500/20 ring-1 ring-emerald-400/40">
            <svg className="h-8 w-8 text-emerald-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <div>
            <h3 className="text-lg font-semibold text-white sm:text-xl">Email sent</h3>
            <p className="mt-2 text-sm leading-relaxed text-white/70">
              We&apos;ve sent a password reset link to{" "}
              <strong className="font-medium text-white">{email}</strong>
            </p>
            <p className="mt-3 text-sm text-white/55">Please check your email and follow the link to reset your password.</p>
          </div>
          <Link to="/Login" className={`${primaryBtn} inline-block`}>
            Back to Sign in
          </Link>
        </div>
      ) : (
        <>
          <div className="mb-8 text-center">
            <h1 className="text-xl font-semibold tracking-tight text-white sm:text-2xl">Forgot password?</h1>
            <p className="mt-2 text-sm leading-relaxed text-white/65">
              Enter your email address and we&apos;ll send you a link to reset your password.
            </p>
          </div>

          <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
            <AuthInput
              label="Email"
              type="email"
              name="email"
              id="email"
              placeholder="Enter Your Email"
              errors={errors}
              register={register}
              variant="glass"
            />

            <div className="pt-1">
              <button type="submit" disabled={loading} className={primaryBtn}>
                {loading ? "Sending…" : "Reset Password"}
              </button>
            </div>
          </form>

          <p className="mt-8 text-center text-sm text-white/75">
            <Link
              to="/Login"
              className="transition hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primaryBlue"
            >
              Remember your password? Sign in
            </Link>
          </p>
        </>
      )}
    </AuthScreenLayout>
  );
}
